import ResponsiveGrid from "../ResponsiveGrid";
import KeyBox from "../TrBoxes/box";

import data from '../../Data/takeawaysTwo.json'
import {Text, Box, Heading} from "grommet";


const columns = {
    small: ["100%"],
    medium: ["35%", "auto"],
    large: ["35%", "auto"],
};

const rows = {
    small: ["auto"],
    medium: ["auto"],
    large: ["auto"],
};

function BoxRow({state}) {
    const stateData = data.find( datum => datum.state === state.toLowerCase())
    const summary = stateData.summaryText
    const takeaways = stateData.takeaways.map(takeaway => takeaway.title)
    const recommendations = stateData.recommendations.map(recommendation => recommendation.title)
    return (
        <ResponsiveGrid
            width="85%"
            gap="medium"
            pad="small"
            overrideColumns={columns}
            overrideRows={rows}
        >
            <Text dangerouslySetInnerHTML={{__html: summary}} alignSelf="center">
            </Text>
            <Box>
                <KeyBox title="Takeaways Summary" points={takeaways} />
                <br />
                <KeyBox title="Recommendations Summary" points={recommendations} />
                <a href="#trRow" style={{alignSelf: "center"}}>
                    <Heading level="3">
                        See detailed Takeaways and Recommendations
                    </Heading>
                </a>
            </Box>
        </ResponsiveGrid>
    );
}

export default BoxRow